import { cn } from '@/lib/utils'

import { StarIcon } from './StarIcon'
import { useStarsVariants } from '../../Theme'

type StarSize = 'xs' | 'sm' | 'default' | 'lg' | 'xl'

interface StarsProps {
  /** Number of filled stars (0-5) */
  totalStars: number
  /** Size variant from CVA config */
  size?: StarSize
  /** Additional container classes */
  className?: string
}

/**
 * Stars - Rating display component
 *
 * Uses CVA variants from UiProvider for consistent styling.
 * For click-to-rate input use StarRatingInput.
 */
export function Stars({ totalStars, size = 'default', className }: StarsProps) {
  const variants = useStarsVariants()
  const label = `${Math.round(totalStars)} din 5 stele`

  return (
    <div
      className={cn(variants.starsContainerVariants({ variant: 'default' }), className)}
      role="img"
      aria-label={label}
    >
      <span className="sr-only">{label}</span>
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className={cn(variants.starIconVariants({ size, interactive: false }))}>
          <StarIcon filled={i < totalStars} className="h-full w-full" />
        </span>
      ))}
    </div>
  )
}
